import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { components } from "react-select";
import { SearchIcon } from "./ProjectIcons";
import { globalSearchClasses } from "./tailwindClassnames";

type GlobalSearchProps = {
    onChangeGlobalSearch: (value: string) => void
    savedString?: string
    placeholder?: string
    showClearButton?: boolean
    clearOnSearch?: boolean
}

const GlobalSearch = ({
    onChangeGlobalSearch,
    savedString,
    placeholder = "",
    showClearButton = true,
    clearOnSearch = false
}: GlobalSearchProps) => {
    const { t } = useTranslation();
    const [subStr, setSubStr] = useState(savedString ? savedString : "");
    // Search filter is applied and the input still shows it — mirror the
    // light-green "active filter" look of the SelectInput dropdowns.
    const isApplied = !!savedString && subStr === savedString;
    // useeffect to rerender the component when savedString changes
    useEffect(() => {
        setSubStr(savedString ? savedString : "");
    }, [savedString]);

    return (
        <div className={globalSearchClasses.container} data-testid='globalsearch'>
            <div className={globalSearchClasses.inputContainer}>
                <div className={globalSearchClasses.inputWrapper}>
                    <input
                        id="globalsearch"
                        data-testid='globalsearch-input'
                        placeholder={placeholder}
                        value={subStr}
                        className={`${globalSearchClasses.input} ${isApplied ? globalSearchClasses.applied : ""}`}
                        onChange={(e) => setSubStr(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                onChangeGlobalSearch(subStr);
                                if (clearOnSearch) setSubStr('');
                            }
                        }}
                    />
                    {showClearButton && subStr && (
                        <button
                            type="button"
                            aria-label={t("Clear keyword filter")}
                            className={globalSearchClasses.clearButton}
                            onClick={() => {
                                setSubStr('')
                                onChangeGlobalSearch('')
                            }}
                        >
                            <components.CrossIcon size={20} />
                        </button>
                    )}
                </div>
                <button className={globalSearchClasses.searchButton}
                    type="button"
                    data-testid='globalsearch-button'
                    onClick={() => {
                        onChangeGlobalSearch(subStr);
                        if (clearOnSearch) setSubStr('');
                    }}
                >
                    <SearchIcon />
                </button>
            </div>
        </div>
    )
};

export default GlobalSearch;